// extracted by mini-css-extract-plugin
export default {"subtitle":"styles_subtitle__IR+SF","okButton":"styles_okButton__pd0Sl"};